module.exports = __webpack_public_path__ + "static/media/freeKick.a4bb85fb.svg";